export const HERO_ASSETS = {
 worried: '/assets/toilet-quiz/hero-worried.webp',
 relieved: '/assets/toilet-quiz/hero-relieved.webp',
 embarrassed: '/assets/toilet-quiz/hero-embarrassed.webp',
} as const;

export function loadHeroArt(): Promise<HTMLImageElement[]> {
 return Promise.all(Object.values(HERO_ASSETS).map(src => new Promise<HTMLImageElement>((resolve, reject) => {
  const image = new Image();
  image.decoding = 'async';
  image.onload = () => { void image.decode().then(() => resolve(image), reject); };
  image.onerror = () => reject(new Error('주인공 이미지를 불러오지 못했어요.'));
  image.src = src;
 })));
}
